import { bunja } from 'bunja';

import { r230522SocketBunja } from './socket';

// context: https://prextech.slack.com/archives/CSJUWFLAG/p1731649392695179
export const tickersBunja = bunja(() => {
  const { r230522Socket } = bunja.use(r230522SocketBunja);
  let currentPswapTicker: string | null = null;
  let currentSpotTicker: string | null = null;

  function getCurrentTicker() {
    return currentPswapTicker || currentSpotTicker;
  }

  function updateSubs() {
    r230522Socket.send({ s: { tickers: getCurrentTicker() } });
  }

  function setCurrentPswapTicker(ticker: string | null = null) {
    currentPswapTicker = ticker;
    currentSpotTicker = null;
    updateSubs();
  }

  function setCurrentSpotTicker(ticker: string | null = null) {
    currentSpotTicker = ticker;
    currentPswapTicker = null;
    updateSubs();
  }

  bunja.effect(() => {
    updateSubs();
    r230522Socket.on('connected', updateSubs);

    return () => {
      updateSubs();
      r230522Socket.off('connected', updateSubs);
    };
  });

  return {
    setCurrentPswapTicker,
    setCurrentSpotTicker,
  };
});
tickersBunja.debugLabel = 'tickersBunja';
